import Table from 'components/Table'
import useIsMobileView from 'hooks/useIsMobileView'
import { useMemo } from 'react'
import FutureMobileBox from './FutureMobileBox'
import { Grid, useTheme } from '@mui/material'
import { TRADE_SIDE } from 'pages/BasicTrade/components/constants'

const headers = [
  {
    key: "side",
    name: "Side",
    align: "center",
  },
  {
    key: "symbol",
    name: "Symbol",
    align: "center",
  },
  {
    key: "leverage",
    name: "Leverage",
    align: "center",
  },
  {
    key: "positionAmount",
    name: "Position Amount",
    align: "center",
  },
  {
    key: "entryPrice",
    name: "Entry Price",
    align: "center",
  },
  {
    key: "positionTotal",
    name: "Position Total",
    align: "center",
  },
  {
    key: "unRealizedProfit",
    name: "Unrealized Profit",
    align: "center",
  },
  {
    key: "liquidationPrice",
    name: "Liquidation Price",
    align: "center",
  },
  {
    key: "markPrice",
    name: "Mark Price",
    align: "center",
  },
  {
    key: "date",
    name: "Date",
    align: "center",
  },
]

function FutureTable({ brokerInfoDetail }) {
  const theme = useTheme()
  const isMobileView = useIsMobileView()

  const sideRowColor = (item) => {
    if (item?.sideId === TRADE_SIDE.Buy.id)
      return `${theme.palette.success.main}20`;
    else return `${theme.palette.error.main}20`;
  }

  const formattedItems = useMemo(() => brokerInfoDetail?.listFuture?.map((item) => ({
    ...item,
    color: sideRowColor(item),
    date: <>{item?.date} {item?.time}</>

    // eslint-disable-next-line react-hooks/exhaustive-deps
  })), [brokerInfoDetail])

  return (
    <>
      {
        isMobileView ?
          <Grid container spacing={1}>
            {brokerInfoDetail?.listFuture?.map((item) => (
              <Grid item xs={12} sm={6}>
                <FutureMobileBox
                  item={item}
                />
              </Grid>
            ))}
          </Grid>
          :
          <Table
            headers={headers}
            items={formattedItems}
          />
      }
    </>
  )
}

export default FutureTable